import { Component } from '@angular/core';
import { fetchUiMessages } from '@app/store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'vf-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(private store: Store) {
    this.store.dispatch(fetchUiMessages());
  }
}
